<script>

    import { createEventDispatcher } from 'svelte'

    export let icon = null
    export let text = null
    export let color = null
    export let options = []

    let isActive = false

    const dispatch = createEventDispatcher()

    function onClick(value) {
        isActive = false
        dispatch('selected', value)
        dispatch('change', value)
    }

</script>

<style>
    a:hover {
        border-bottom: none !important;
    }
</style>

<div class="dropdown" class:is-active={isActive}>
    <div class="dropdown-trigger">
        <button on:click={() => isActive = !isActive} class="button is-{color}" aria-haspopup="true" aria-controls="dropdown-menu">
            {#if icon}
                <span class="icon"><i class="fas fa-{ icon }"></i></span>
            {/if}
            {#if text}
                <span>{ text }</span>
            {/if}
            <span class="icon is-small">
                <i class="fas fa-angle-down" aria-hidden="true" />
            </span>
        </button>
    </div>
    <div class="dropdown-menu" id="dropdown-menu" role="menu">
        <div class="dropdown-content">
            {#each options as option}
                {#if option.isDivider}
                    <hr class="dropdown-divider" />
                {:else if option.html}
                    <div on:click={() => onClick(option.value)} class="dropdown-item">
                        {@html option.html}
                    </div>
                {:else}
                    <a on:click={() => onClick(option.value)} class="dropdown-item">{ option.text }</a>
                {/if}
            {/each}
        </div>
    </div>
</div>